// import Axios from 'axios'
import { competitionTypes } from '../constants/competitionTypes'
import api from './api'

const competitionBasePath = '/api/v1/competition'

export async function listCompetitions(params, cancelToken) {
  const resp = await api.get(`${competitionBasePath}/list`, {
    params: { ...params },
    cancelToken
  })
  return resp.data
}

export async function getCompetitionCounts(getQueryParams) {
  const resp = await api.get(`${competitionBasePath}/count`, { params: getQueryParams })
  return resp.data
}

export async function getCompetitionCountsSoleProprietorship(getQueryParams) {
  const resp = await api.get(`${competitionBasePath}/count-sole-proprietorship`, { params: getQueryParams })
  return resp.data
}

export async function getSelectedCompetitions(getQueryParams) {
  const resp = await api.get(`${competitionBasePath}/competitions`, { params: getQueryParams })
  return resp.data
}

export async function getCompetitions(getQueryParams) {
  const resp = await api.get(`${competitionBasePath}`, { params: getQueryParams })
  return resp.data
}

export async function getCompetitionsSoleProprietorship(getQueryParams) {
  const resp = await api.get(`${competitionBasePath}/sole-proprietorship`, { params: getQueryParams })
  return resp.data
}

export async function getCompetition(competitionId) {
  const resp = await api.get(`${competitionBasePath}/${competitionId}`)
  return resp.data
}

export async function getCompetitionWithDetails(competitionId) {
  const resp = await api.get(`${competitionBasePath}/detailed/${competitionId}`)
  return resp.data
}

export async function createCompetition(data) {
  const resp = await api.post(`${competitionBasePath}`, data)
  return resp.data
}

export async function editCompetiton(data, competitionId) {
  const resp = await api.patch(`${competitionBasePath}/${competitionId}`, data)
  return resp.data
}

export async function validateCompetition(data, competitionId) {
  const resp = await api.patch(`${competitionBasePath}/validate/${competitionId}`, data)
  return resp.data
}

export async function validateDraftCompetition(competitionId) {
  const resp = await api.patch(`${competitionBasePath}/validate-draft/${competitionId}`)
  return resp.data
}

export async function testCompetitionCreate(step) {
  let request = {}
  switch (step) {
    case 1: {
      request = {
        step,
        name: 'Test123 Test123 Test123',
        code: 'code',
        link: 'google.com',
        mainPageLink: 'valami link',
        type: competitionTypes.CREDIT
      }
      break
    }
    case 2: {
      var preQualificationEnd = new Date()
      preQualificationEnd.setDate(preQualificationEnd.getDate() - 5)
      request = {
        step,
        mainPageLink: 'valami link',
        type: competitionTypes.CAPITAL_PRODUCT,
        subsidy: '',
        preQualification: false,
        qualificationStart: new Date(),
        qualificationEnd: new Date(),
        preQualificationStart: new Date(),
        preQualificationEnd
      }
      break
    }
  }
  const resp = await api.post(`${competitionBasePath}`, request)
  return resp.data
}

export async function getApplicationsForRestriction() {
  const resp = await api.get(`${competitionBasePath}/list-name-code`)
  return resp.data
}

export async function getRistrictionsByCompetitions() {
  const resp = await api.get(`${competitionBasePath}/restriction-competitions`)
  return resp.data
}
